import { FileError } from "@rhybus/common-functions"
import { FILE_CHARACTERS_UNALLOWED, MAX_FILE_SIZE } from "./Configuration"
import { getFileExtensionByFileName } from "./shared/utility/fileHelpers"
import { format } from 'date-fns'


export const validateFile = (file: File, supportedFiles: string[], isPMGFile?: boolean): [boolean, Array<FileError>] => {
  let valid = true
  const errors: Array<FileError> = []
  const FileTypes = supportedFiles
  const ext = getFileExtensionByFileName(file.name)
  if (isPMGFile && file?.name?.length > 128) {
    errors.push({ fileName: `${file.name}`, message: 'File Name exceeds max length. Max file name length is 128 characters.' })
    valid = false
  }
  if (file.size > MAX_FILE_SIZE) {
    errors.push({ fileName: `${file.name}`, message: 'File cannot exceed 25MB.' })
    valid = false
  }
  if (FileTypes.indexOf(ext) === -1) {
    errors.push({ fileName: `${file.name}`, message: `File type is not allowed. Acceptable file types are ${FileTypes.join(', ')}.` })
    valid = false
  }
  if (FILE_CHARACTERS_UNALLOWED.some(char => file.name.includes(char))) {
    errors.push({ fileName: `${file.name}`, message: `File name contains unallowed characters. Unallowed characters are ${FILE_CHARACTERS_UNALLOWED.join(' ')}.` })
    valid = false
  }
  return [valid, errors]
}


/* This DocumentIconNames function is used to get fileName extension class name and it returns the icon  class name */
export function DocumentIconNames(file: string): string {
  const fileExtension = file?.split('.').pop() ? file?.split('.')?.pop()?.toLowerCase() : ''
  const iconName = (fileExtension === 'ppt' || fileExtension === 'pptx')
    ? 'icon-rb-ms-powerpoint-fill icon-pptcolor'
    : (fileExtension === 'pdf')
      ? 'icon-rb-file-pdf-earmark-fill icon-pdfcolor'
      : (fileExtension === 'doc' || fileExtension === 'docx')
        ? 'icon-rb-word-doc-fill color-primary'
        : (fileExtension === 'xlsx' || fileExtension === 'xls')
          ? 'icon-rb-ms-excel-outline icon-excelcolor'
          : (fileExtension === 'txt')
            ? 'icon-rb-file-empty-earmark color-primary'
            : (fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg')
              ? 'icon-rb-file-png icon-png-jpgcolor'
              : (fileExtension === 'msg')
                ? 'icon-rb-email'
                : (fileExtension === 'gif') ? 'icon-rb-file-gif color-primary' : 'icon-rb-file'
  return iconName
}

//Get colorcodes through css variables
export const getColorCodeFromCSSVariable = (variableName: string) => {
  return getComputedStyle(document.documentElement).getPropertyValue(variableName)
}

export function getStatusColorCSSClass(status: string) {
  switch (status) {
    case 'healthy':
      return 'color-success'
    case 'warning':
      return 'color-warning'
    case 'critical':
      return 'color-failed'
  }
}

/* This convertDate function is used to convert 
given date to Data and Time hours, minutes and Am or PM formats */
export function convertDate(serverDate: string | number | Date | null | undefined, formatter: string) {
  let createdDate = ''
  if (serverDate !== '' && serverDate !== null && serverDate !== undefined) {
    const dt = new Date(serverDate)

    // Simple format options - easy to use, no complex format strings needed
    switch (formatter) {
      case 'date':
        createdDate = format(dt, 'MM/dd/yyyy hh:mm a')
        break
      case 'year-first':
        createdDate = format(dt, 'yyyy/MM/dd')
        break
      case 'year-first-time':
        createdDate = format(dt, 'yyyy/MM/dd hh:mm a')
        break
      default:
        createdDate = format(dt, 'MM/dd/yyyy')
    }
  }
  return createdDate
}

 
export const generateSessionId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
 
  const now = Date.now().toString(36);
  const rand = Math.random().toString(36).slice(2, 10);
  return `${now}-${rand}`;
};
 